const File = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 260" width={"100%"} height={"100%"}>
        <path strokeWidth={20} strokeMiterlimit={10} fill={"none"} stroke={"#1d1d1b"} d="m194.93,77.84v144.83c0,13.33-10.81,24.14-24.14,24.14H44.93c-13.33,0-24.14-10.81-24.14-24.14V40.78c0-13.33,10.81-24.14,24.14-24.14h87.07l62.93,61.21Z"/>
        <path strokeWidth={20} strokeMiterlimit={10} fill={"none"} stroke={"#1d1d1b"} d="m194.93,77.84h-38.79c-13.33,0-24.14-10.81-24.14-24.14V16.64"/>
    </svg>
)

export default File;